import _objectWithoutProperties from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children"];
import _extends from '@babel/runtime/helpers/esm/extends';
import * as THREE from 'three';
import * as React from 'react';
function createScreenQuadGeometry() {
  const geometry = new THREE.BufferGeometry();
  const vertices = new Float32Array([-1, -1, 3, -1, -1, 3]);
  geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 2));
  return geometry;
}
const ScreenQuad = /*#__PURE__*/React.forwardRef(function ScreenQuad(_ref, ref) {
  let {
      children
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const geometry = React.useMemo(createScreenQuadGeometry, []);
  return /*#__PURE__*/React.createElement("mesh", _extends({
    ref: ref,
    geometry: geometry,
    frustumCulled: false
  }, restProps), children);
});
export { ScreenQuad };